export const faqGroups = [
  {
    title: "Learning",
    items: [
      {
        q: "What does “learn Spanish from Russian” mean?",
        a: "Every course is a pair: a language you want to learn, taught from a language you already know. Explanations, translations and grammar notes are written for your base language. You can take the same target language from several bases, and each pair tracks its own progress.",
      },
      {
        q: "How many languages are there?",
        a: "Over 60 target languages. English has the most courses as a base language; Russian, Italian, Spanish, German, French and several others each offer a growing set of pairs.",
      },
      {
        q: "Where does the content come from?",
        a: "Most courses are adapted from Loescher Editore's language materials. The in-app book and the games in each unit come from the same chapters, aligned to CEFR levels A1–C1.",
      },
      {
        q: "Do I need a microphone?",
        a: "Only for “Say it out loud” exercises, which work best in Chrome or Edge. You can switch speaking exercises off in Settings any time.",
      },
    ],
  },
  {
    title: "The translator",
    items: [
      {
        q: "What happens to words I translate?",
        a: "With “Remember” on, each lookup is saved to My Words for the matching course pair. Saved words are blended into your regular lessons (tagged “From your translator”) and can be practised on their own from My Words.",
      },
      {
        q: "Can I stop it saving?",
        a: "Yes. Toggle “Remember what I translate” off on the Translate screen, or remove any word from My Words.",
      },
    ],
  },
  {
    title: "Plans & billing",
    items: [
      {
        q: "Is the free plan really free?",
        a: "Yes — one course pair, all seven game types and the translator, with no time limit. Plus unlocks unlimited pairs, hearts, saved words and the full offline book.",
      },
      {
        q: "Can I cancel Plus?",
        a: "Any time from Profile → Subscription. You keep Plus until the end of the billing period, and your saved words and progress stay.",
      },
      {
        q: "Do you offer school licences?",
        a: "We're piloting classroom plans with a few schools this year. Write to us from the Contact page.",
      },
    ],
  },
];
